<form [formGroup]="receiverForm" (ngSubmit)="AgregarEmail()" name="receiverForm" *ngIf="!isGrupos">
    <div class="form-group">
        <label class="ms-Label">Correo Electrónico</label>
        <input
          class="form-control"
          type="text"
          placeholder="Correo electrónico..."
          [(ngModel)]="EmailDestinatario"
          formControlName="EmailDestinatario"
        />
        <p style="color: brown; display: none;" id='duplicateEmailError'></p>
        <p style="color: brown;" *ngIf="receiverForm.controls.EmailDestinatario.value && (receiverForm.controls.EmailDestinatario.invalid && (receiverForm.controls.EmailDestinatario.dirty || receiverForm.controls.EmailDestinatario.touched))"> El correo electrónico no cuenta con el formato correcto </p>
    </div>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button
        type="submit"
        class="ms-Button ms-Button--primary" [disabled]="receiverForm.invalid"
      >
        <span class="ms-Button-label">Agregar</span>
      </button>
    </div>
</form>
<br/>
<p><strong> Destinatarios restantes: </strong><span id='stackReceivers'>{{counterReceivers}}</span></p>
<table
datatable
[dtOptions]="dtOptionsDestinatarios"
[dtTrigger]="dtTriggerDestinatario"
class="ms-Table ms-Table--selectable order-column row-border"
style="width: 100%"
id="datatableDestinatarios"></table>
<!-- <ng-container *ngIf="isVisible$ | async">
  <app-local-data-table [columns]="columnasDestinatario" [(items)]="destinatariosGrid" [buttonsOptions]="dtOptButtonsDestinatarios"></app-local-data-table> 
</ng-container> -->

<br/>
<button id="btnAddPermission" type="button" class="ms-Button ms-Button--primary" (click)="abrirDataTableModal()"> <span class="ms-Button-label">Agregar Usuario</span> </button>
<br/>
<div class="docs-DialogExample-lgHeader">
    <div class="ms-Dialog ms-Dialog--lgHeader modal-destinatarios-usuario" appPreventOutsideClick>
      <div id="divModalPermisosUsuario" class="ms-Dialog-title">
        Agregar Usuario
      </div>
      <app-data-table isExcludedData ="usuarios" isNotifyData="true" tableId="datatableDestinatariosUsuario" [serverSide]="true" [serverData]="getUsuarios" [columns]="columnasDestinatario" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtonsDestinatariosUsuario"></app-data-table>
      <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button
          class="ms-Button ms-Button--primary"
          type="button"
          (click)="closeDataTableModal()"
        >
          <span class="ms-Button-label">Aceptar</span>
        </button>
  
      </div>
    </div>
  </div>

  <div class="ms-Dialog-actions" [hidden]="botonProcesando">
    <button
      type="button"
      class="ms-Button ms-Dialog-action"
      (click)="abrirDataTableGrupos()"
    >
      Cancelar
    </button>
    <div style="float: right">
      <button *ngIf="!isGrupos"
        id="saveDestinatarios"
        class="ms-Button ms-Button--primary"
        (click)="abrirModalDestinatarios()"
        
      >
        <span class="ms-Button-label">Guardar destinatarios</span>
      </button>
      <button *ngIf="isGrupos"
        id="saveDestinatarios"
        class="ms-Button ms-Button--primary"
        (click)="abrirModalUsuarios()"
        
      >
        <span class="ms-Button-label">Guardar usuarios</span>
      </button>
    </div>
  </div>


  <!-- Modal Confirmacion Permisos -->
  <div class="docs-DialogExample-lgHeader success">
    <div class="ms-Dialog ms-Dialog--lgHeader guardar-destinatarios" appPreventOutsideClick>
      <div class="ms-Dialog-title">Guardar destinatarios</div>
      <div class="ms-Dialog-content">
        <p class="ms-Dialog-subText">¿Desea guardar los destinatarios seleccionados?</p>
      </div>
      <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>
        <button (click)="guardarDestinatariosNotificacion()" class="ms-Button ms-Dialog-action ms-Button--primary">
          <span class="ms-Button-label">Guardar</span>
        </button>
      </div>
    </div>
  </div>



  <!-- Modal Confirmacion Usuarios Grupo -->
  <div class="docs-DialogExample-lgHeader success">
    <div class="ms-Dialog ms-Dialog--lgHeader guardar-usuarios">
      <div class="ms-Dialog-title">Guardar usuarios</div>
      <div class="ms-Dialog-content">
        <p class="ms-Dialog-subText">¿Desea guardar los usuarios seleccionados?</p>
      </div>
      <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>
        <button (click)="guardarUsuariosGrupo()" class="ms-Button ms-Dialog-action ms-Button--primary">
          <span class="ms-Button-label">Guardar</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Modal Regreso Datatable -->
  <div class="docs-DialogExample-lgHeader success">
    <div class="ms-Dialog ms-Dialog--lgHeader datatable-procesos">
      <div class="ms-Dialog-title">Destinatarios guardados</div>
      <div class="ms-Dialog-content">
        <p class="ms-Dialog-subText">Destinatarios almacenados exitosamente</p>
      </div>
      <div class="ms-Dialog-actions">
        <button
          class="ms-Button ms-Dialog-action ms-Button--primary"
          (click)="closeDataTableModal()"
        >
          <span class="ms-Button-label">Aceptar</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Modal Regreso Datatable Usuarios -->
  <div class="docs-DialogExample-lgHeader success">
    <div class="ms-Dialog ms-Dialog--lgHeader datatable-usuarios">
      <div class="ms-Dialog-title">Usuarios guardados</div>
      <div class="ms-Dialog-content">
        <p class="ms-Dialog-subText">Usuarios almacenados exitosamente</p>
      </div>
      <div class="ms-Dialog-actions">
        <button
          class="ms-Button ms-Dialog-action ms-Button--primary"
          (click)="abrirDataTableGrupos()"
        >
          <span class="ms-Button-label">Aceptar</span>
        </button>
      </div>
    </div>
  </div>




    <!-- Modal Confirmacion Eliminar Usuarios Grupo -->
  <div class="docs-DialogExample-lgHeader success">
    <div class="ms-Dialog ms-Dialog--lgHeader eliminar-usuarios">
      <div class="ms-Dialog-title">Eliminar usuario</div>
      <div class="ms-Dialog-content">
        <p class="ms-Dialog-subText">¿Desea eliminar el usuario seleccionado?</p>
      </div>
      <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>
        <button (click)="eliminarUsuarioDataTable(campo)" class="ms-Button ms-Dialog-action ms-Button--primary">
          <span class="ms-Button-label">Eliminar</span>
        </button>
      </div>
    </div>
  </div>
  


  <app-modal-notify #crearModal></app-modal-notify>